import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import transformAudioPlayer from '../audioplayer-transformer/audioplayer-transformer';
import { ArticleOverviewProps } from '../../../components/ArticleOverview/types/propsTypes';

const transformArticleOverview = (data: CMSTransformerDataType): ArticleOverviewProps => {
  const contentDetailGallery = Array.isArray(data?.article_overview)
    ? data?.article_overview[0]
    : data?.article_overview;

  return {
    componentType: ComponentType.article_overview,
    tag: contentDetailGallery?.overview?.tagline,
    title: contentDetailGallery?.overview?.title,
    description: contentDetailGallery?.overview?.description,
    subTitle: contentDetailGallery?.overview?.sub_title,
    imageList: contentDetailGallery?.image?.images?.map((image: CMSTransformerDataType) => ({
      url: image?.image.url,
      altText: image?.alt_text,
      viewport: image?.viewport,
    })),
    audioFile: transformAudioPlayer(contentDetailGallery?.audio),
  };
};

export default transformArticleOverview;
